import { PermissionModel } from './permission.model';

export class SectionModel {

  public id: number = null;
  public sectionName: string = null;
  public permissions: PermissionModel[] = [];
  constructor(
  ) {}
}
